<template>
  <div>
    <el-form-item label="健康证明" :rules="[{ required: true, message: '请上传图片' }]" prop="model.image">
      <el-row>
        <el-button type="primary" @click="openProductUpload('image','health_image')">选择图片</el-button>
        <div v-if="form.aptitude && form.aptitude.certificate!=''" class="img">
          <img :src="form.aptitude.certificate" width="100" height="100" />
        </div>
      </el-row>
    </el-form-item>
  </div>
</template>
<script>
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
export default {
  components: {
    Upload,
    draggable
  },

  data() {
    return {
      isProductUpload: false,
      config: {},
      file_name: "image"
    };
  },
  inject: ["form"],
  mounted() {},
  computed: {},
  methods: {
    /*打开上传图片*/
    openProductUpload: function(fileType, file_name) {
      this.file_name = file_name;
      if (fileType == "image") {
        this.config = {
          total: 1,
          fileType: "image"
        };
      } else {
        this.config = {
          total: 1,
          fileType: "video"
        };
      }
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        if (this.file_name == "video") {
          this.form.waiter.video_id = e[0].fileId;
          this.form.waiter.video = e[0];
        } else if (this.file_name == "health_image") {
          this.form.aptitude.certificate = e[0].filePath;
        }
      }
      this.isProductUpload = false;
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/technician/technicianlist/part/health.vue